import React, { useState } from "react";
import { components } from "react-select";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { ClientListType } from "../../../../screens/Scheduling/ScheduleReports/ClientJobScheduling";
import {
  CloseIcon,
  filterBlackIcon,
  FilterIcon,
} from "../../../../assets/images";
import { CircularAvatar, DropDown, RadioContainer } from "../../../commons";
import { UserListType } from "../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { ID_PASSWORD_CATEGORY_LIST } from "../../../../constant/idPasswordCategoryList";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import { SelectedFilterType } from "../../../../redux/stcoTools/stcoToolsType";
import { FILE_ATTACHMENT_RADIO_OPTIONS } from "../../../../constant/tableHeadersConstants/stcoTools/idPasswordManagerTableHeader";

type AppProps = {
  type:string;
  clientSelected?: ClientListType;
  finalClientList?: ClientListType[] | [];
  handleChangeClient?: (data: any) => void;
  checkBottom?: (data: any) => void;
  setLoadCondition: (data: boolean) => void;
  setText?: (data: string) => void;
  setOffset?: (data: number) => void;
  assignedClientsToUserFetching?: boolean;
  onMenuClose: () => void;
  loadCondition: boolean;
  handleFilter: (type: string) => void;
  setClientSelected?: (data: ClientListType) => void;
  setUserSelected:(data: ClientListType) => void;
  filter: boolean;
  setFilter: (data: boolean) => void;
  userFetching: boolean;
  userSelected:ClientListType;
  finalUserList:UserListType[] | [] | any;
  handleUserChange:(e:any)=>void;
  setUserText:React.Dispatch<React.SetStateAction<string>>
  setUseroffset:React.Dispatch<React.SetStateAction<number>>
  checkUserBottom:(e:any)=>void;
  selectCategory:OptionsType;
  setSelectCategory:(data:OptionsType)=>void;
  handleCategoryChange:(e:any)=>void;
  isFilterSelected:React.MutableRefObject<SelectedFilterType>;
  fileAttachmentStatus:string;
  setFileAttachmentStatus:React.Dispatch<React.SetStateAction<string>>;
  fileAttachementStatusValue:string;
  setfileAttachmentStatusValue:React.Dispatch<React.SetStateAction<string>>;
};

const IdPasswordFilter = ({
  type,
  clientSelected,
  finalClientList,
  handleChangeClient,
  checkBottom,
  checkUserBottom,
  setLoadCondition,
  assignedClientsToUserFetching,
  onMenuClose,
  setText,
  setOffset,
  handleFilter,
  loadCondition,
  setClientSelected,
  setUserSelected,
  filter,
  setFilter,
  userFetching,
  userSelected,
  finalUserList,
  handleUserChange,
  setUserText,
  setUseroffset,
  selectCategory,
  setSelectCategory,
  handleCategoryChange,
  isFilterSelected,
  fileAttachmentStatus,
  setFileAttachmentStatus,
  fileAttachementStatusValue,
  setfileAttachmentStatusValue
}: AppProps) => {
  const [toggle, setToggle] = useState<boolean>(false);

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
         {data?.value ? <CircularAvatar
            name={data?.label}
            image={data?.image && data?.image}
          /> : null}
          {data?.label}
        </div>
      </components.Option>
    );
  };


  const handleSetTokenStatusRadioValue = (radioValue: string) => {
    setfileAttachmentStatusValue(radioValue);
  };

 
  const handleSubmit = () => {
    const isClientSelected = !!clientSelected?.value;
    const isUserSelected = !!userSelected?.value;
    const isCategorySelected = !!selectCategory?.value;
    const isFileAttachmentSelected = fileAttachementStatusValue !== undefined && fileAttachementStatusValue !== null;
  
    // Update isFilterSelected ref
    isFilterSelected.current = {
      client: isClientSelected,
      user: isUserSelected,
      category: isCategorySelected,
      fileAttachment: isFileAttachmentSelected,
    };
  
    // Handle filter logic
    if (isClientSelected || isUserSelected || isCategorySelected || isFileAttachmentSelected) {
      handleFilter("add");
      setOffset && setOffset(0);
      setUseroffset(0);
    }
  };
  


  const clearFilter = () => {
    isFilterSelected.current={client:false,user:false,category:false,fileAttachment:false}
    setOffset && setOffset(0);
    setUseroffset(0);
    handleChangeClient && handleChangeClient("");
    setClientSelected && setClientSelected({
      value: null,
      label: "Select..",
    });

    setUserSelected({
      value: null,
      label: "Select..",
    })

    setSelectCategory({
      value: null,
      label: "Select..",
    })
    setfileAttachmentStatusValue("")
    setFileAttachmentStatus("")

    if (filter) {
      handleFilter("clear");
    }
    setFilter(false);
  };
  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
  
          if(!isFilterSelected?.current?.client){
            setClientSelected && setClientSelected({
              value: null,
              label: "Select..",
            });
          }
         
          if(!isFilterSelected?.current?.user){
            setUserSelected({
              value: null,
              label: "Select..",
            })
          }
          
          if(!isFilterSelected?.current?.category){
            setSelectCategory({
              value: null,
              label: "Select..",
            })
          }
          if(!isFilterSelected?.current?.fileAttachment){
          
            setfileAttachmentStatusValue("")

          }
          


      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-download-invoice">Filter</Tooltip>}
      >
        <DropdownToggle
          caret
          color="secondary"
          style={
            toggle ||
            (!clientSelected?.value)
              ? { border: "1px solid#bfcbe1" }
              : {
                  color: "#dd4433",
                  border: "1px solid #dd4433",
                  backgroundColor: "#fff6f5",
                }
          }
          outline
        >
          <img src={toggle ? FilterIcon : filterBlackIcon} alt="" />

          {filter ? (
            <span className={"filter-count"}>
              <span>
                {(+isFilterSelected?.current?.client) + (+isFilterSelected?.current?.user) + (+isFilterSelected?.current.category) + (+isFilterSelected?.current.fileAttachment)}
              </span>
            </span>
          ) : null}
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right>
        <div className="download-dropdown p-3">
          <div className="d-flex justify-content-between align-items-center mt-0 mb-0">
            <h5 className="text-center ">Filter</h5>
            <div
              className="pointer"
              onClick={() => {
                setToggle(!toggle);
                if(!isFilterSelected?.current?.client){
                  setClientSelected && setClientSelected({
                    value: null,
                    label: "Select..",
                  });
                }
               
                if(!isFilterSelected?.current?.user){
                  setUserSelected({
                    value: null,
                    label: "Select..",
                  })
                }
                
                if(!isFilterSelected?.current?.category){
                  setSelectCategory({
                    value: null,
                    label: "Select..",
                  })
                }
                if(!isFilterSelected?.current?.fileAttachment){
                  setfileAttachmentStatusValue("")
                }
              }}
            >
              <img src={CloseIcon} alt="" />
            </div>
          </div>
          <hr className="mt-0 mb-0" />

         {type==="sideBar" ? <div className="mt-1 ml-1">
            <label className="mb-1">Select Client</label>
            <div>
              <Select
                value={clientSelected}
                cacheOptions
                options={finalClientList?.length ? [{label:"Select...",value:null},...finalClientList] : []}
                onChange={handleChangeClient}
                // onMenuScrollToBottom={(e: any) => checkBottom && checkBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setText && setText(e);
                  setOffset && setOffset(0);
                }}
                onMenuClose={onMenuClose}
                isLoading={loadCondition && assignedClientsToUserFetching}
              />
            </div>
          </div> : null}

          <div className="mt-1 ml-1">
          <div className="form-group">
              <label>Access to team members</label>
              <Select
                className="dropdown"
                placeholder="Search User"
                value={userSelected}
                options={finalUserList?.length ? [{label:"Select...",value:null},...finalUserList] : []}
                onChange={handleUserChange}
                components={{ Option }}
                isLoading={userFetching}
                onMenuClose={onMenuClose}
                isSearchable={true}
                onMenuScrollToBottom={(e: any) => checkUserBottom(e)}
                onInputChange={(e: string) => {
                  setLoadCondition(false);
                  setUserText(e);
                  setUseroffset(0);
                }}
              />
            </div>
          </div>

          <div>
          <label>Category</label>
              <DropDown
                options={[{label:"Select...",value:null},...ID_PASSWORD_CATEGORY_LIST]}
                value={selectCategory}
                handleChange={handleCategoryChange}
              />
          </div>



          <div className="mt-4 ms-1">
            <div style={{ color: "#6e7491" }}>File Attachment</div>
            <div>
              <RadioContainer
                optionsList={FILE_ATTACHMENT_RADIO_OPTIONS}
                handleSetRadioValue={handleSetTokenStatusRadioValue}
                radioValue={fileAttachementStatusValue}
                alignment="horizontal"
              />
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end p-3 ">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="btn btn-primary mr-3"
            onClick={() => {
              handleSubmit();
              setToggle(!toggle);
            }}
            // disabled={
            //   !clientSelected?.value  && !selectCategory?.value && !userSelected?.value
            // }
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default IdPasswordFilter;
